import React, { useState } from 'react';
import { Modal, InputNumber, Typography, Space, Alert } from 'antd';
import api from '../../../services/api';

const { Text } = Typography;

export default function OpeningBalanceModal({ open, communityTeamId, onClose, onSaved }) {
  const [value, setValue] = useState(0);
  const [saving, setSaving] = useState(false);

  const save = async () => {
    setSaving(true);
    try {
      await api.post('/community/finance/accounts/opening', {
        community_team_id: communityTeamId,
        opening_balance_brl: Number(value || 0),
      });
      onSaved?.();
    } catch (e) {
      Modal.error({ title: 'Erro', content: e.response?.data?.message || 'Falhou salvar' });
    } finally { setSaving(false); }
  };

  return (
    <Modal open={open} title="Saldo inicial do time"
      onCancel={onClose} onOk={save} confirmLoading={saving}
      okText="Salvar saldo inicial" cancelText="Começar do zero"
      cancelButtonProps={{ onClick: async () => { await save(); onClose?.(); } }}>
      <Space direction="vertical" style={{ width: '100%' }}>
        <Text>Já tinha dinheiro no caixa do time? Informa o saldo inicial pra começar do jeito certo.</Text>
        <Alert type="info" showIcon
          message="Não dá pra editar depois."
          description="Se preferir começar do zero, escolhe 'Começar do zero'. Depois você pode registrar entradas/saídas normalmente." />
        <InputNumber value={value} onChange={setValue}
          min={0} step={1} precision={2}
          prefix="R$" style={{ width: '100%' }}
          placeholder="0,00" />
      </Space>
    </Modal>
  );
}
